import { render, staticRenderFns } from "./CollegeSubscriptionPracticeTestsChildTopicTest.vue?vue&type=template&id=7240a30b&scoped=true"
import script from "./CollegeSubscriptionPracticeTestsChildTopicTest.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptionPracticeTestsChildTopicTest.vue?vue&type=script&lang=js"
import style0 from "./CollegeSubscriptionPracticeTestsChildTopicTest.vue?vue&type=style&index=0&id=7240a30b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7240a30b",
  null
  
)

export default component.exports